<template>
  <div class="pre-selection">
    <img class="bg" src="./images/bg1.png" alt="" />
    <img
      class="img-rank"
      src="./images/rank.png"
      alt=""
      v-if="ranking || !isPlayer"
    />
    <img
      class="img-more-rank"
      src="./images/more-rank.png"
      alt=""
      v-if="!ranking && isPlayer"
    />
    <div class="avatar-box" v-if="!userInfo">
      <img class="avatar-frame" src="./images/avatar-frame.png" alt="" />
      <img
        class="avatar"
        src="https://resource.funplus.social/user-static/49f35e22-aa6c-4c5c-aa17-dd5f544fa1396337067608568951349.png?d=100x100"
        alt=""
      />
    </div>
    <div class="avatar-box" v-else>
      <img class="avatar-frame" :src="userInfo.avatarFrame" alt="" />
      <img class="avatar" :src="userInfo.avatarUrl" alt="" />
    </div>
    <div class="avatar-box2">
      <img
        class="avatar-frame"
        src="https://resource.3uplay.com/sys-feed/0dc4f7f1-2481-4c1c-b035-ffbecf56ca004424340673899612825.webp"
        alt=""
      />
      <img class="avatar" src="./images/avatar.png" alt="" />
    </div>
    <div class="score">{{ isPlayer ? score : '--' }}</div>
    <div class="ranking" v-if="!isPlayer || (isPlayer && ranking)">
      {{ ranking ? ranking : '--' }}
    </div>
    <div class="time">
      <span class="day">{{ day }}</span>
      <span class="hour">{{ hour }}</span>
      <span class="minutes">{{ minutes }}</span>
      <span class="second">{{ second }}</span>
    </div>
    <div class="gift-score">{{ giftScore }}</div>
    <div class="list-box" v-if="giftScoreList && giftScoreList.length">
      <div
        class="list-item"
        v-for="(item, index) of giftScoreList"
        :key="item.user_uuid"
      >
        <div class="left">
          <span class="index">{{ index + 1 }}</span>
          <div class="avatar-box" @click="toPlayerDetail(item.user_uuid)">
            <!-- <img class="avatar-frame" src="./images/avatar-frame.png" alt="" /> -->
            <img class="avatar" :src="item.avatar_url" alt="" />
          </div>
          <span class="user-name">{{ item.user_nickname }}</span>
        </div>
        <div class="right">
          <span class="scroe">{{ item.jifen }}積分</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PreSelection',
  props: {
    honorData: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      day: 0,
      hour: 0,
      minutes: 0,
      second: 0,
      giftScore: 0,
      giftScoreList: []
    };
  },
  computed: {
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    score() {
      return this.honorData ? this.honorData.currentAmount || 0 : 0;
    },
    ranking() {
      return this.honorData ? this.honorData.rankNum || 0 : 0;
    },
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getGiftScore(val);
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    countdownTimer() {
      const targetDateUTC = new Date('2024-01-10T15:59:59Z'); // Convert target date to UTC
      const targetDateLocal = targetDateUTC.toLocaleString('en-US', {
        timeZone: 'Asia/Shanghai'
      }); // Convert UTC to Beijing time
      const targetDate = new Date(targetDateLocal).getTime(); // Get target date in milliseconds
      const now = new Date().getTime(); // Get current date in milliseconds
      const difference = targetDate - now; // Calculate time difference
      if (now < targetDate) {
        // Calculate time remaining
        let days = Math.floor(difference / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((difference % (1000 * 60)) / 1000);
        // Add leading zeros if needed
        days = String(days).padStart(2, '0');
        hours = String(hours).padStart(2, '0');
        minutes = String(minutes).padStart(2, '0');
        seconds = String(seconds).padStart(2, '0');
        this.day = days;
        this.hour = hours;
        this.minutes = minutes;
        this.second = seconds;
      } else {
        this.day = '--';
        this.hour = '--';
        this.minutes = '--';
        this.second = '--';
      }
    },
    async getGiftScore() {
      const { data } = await this.$http.get(
        process.env.VUE_APP_ENV === 'production'
          ? `https://devops.nicee.app/api/ndsd/user/${this.uuid}`
          : `http://43.198.128.138:19999/ndsd/user/${this.uuid}`
      );
      if (data) {
        this.giftScore = data.jifen || 0;
      }
    },
    async getGiftScoreList() {
      const { data } = await this.$http.get(
        process.env.VUE_APP_ENV === 'production'
          ? 'https://devops.nicee.app/api/ndsd/user/rank'
          : 'http://43.198.128.138:19999/ndsd/user/rank'
      );
      if (data) {
        this.giftScoreList = data || [];
      }
    },

    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    }
  },
  mounted() {
    setInterval(this.countdownTimer, 1000);
  },
  created() {
    this.getGiftScoreList();
  }
};
</script>
<style lang="scss" scoped>
.pre-selection {
  width: 100%;
  height: 5287px;
  position: relative;
  font-size: 38px;
  color: #f8e3c2;
  > .bg {
    width: 100%;
    max-width: 100%;
  }
  > .img-rank {
    position: absolute;
    width: 254px;
    top: 427px;
    left: 387px;
  }
  > .img-more-rank {
    position: absolute;
    width: 254px;
    top: 427px;
    left: 387px;
  }
  > .avatar-box,
  .avatar-box2 {
    position: absolute;
    left: 158px;
    top: 325px;
    width: 175px;
    height: 175px;
    border-radius: 50%;
    overflow: hidden;

    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
    }

    .avatar {
      z-index: 1;
      border-radius: 50%;
      object-fit: cover;
    }
    .avatar-frame {
      z-index: 2;
      border-radius: 50%;
      object-fit: cover;
      width: 120%;
      height: 120%;
    }
  }
  .avatar-box2 {
    top: 1641px;
    left: 182px;
    width: 189px;
    height: 189px;
  }
  .score {
    position: absolute;
    top: 350px;
    left: 668px;
  }
  .ranking {
    position: absolute;
    top: 429px;
    left: 513px;
    display: inline-block;
    width: 86px;
    text-align: center;
  }
  .time {
    position: absolute;
    top: 579px;
    left: 375px;
    display: flex;
    align-items: center;
    font-size: 41px;
    > span {
      display: inline-block;
      margin-right: 62px;
      width: 63px;
      text-align: center;
    }
    // .day {
    //   margin-right: 72px;
    // }
    // .hour {
    //   margin-right: 77px;
    // }
    // .minutes {
    //   margin-right: 73px;
    // }
  }
  .list-box {
    position: absolute;
    top: 3408px;
    width: 838px;
    left: 70px;
    border: 1px solid black;
  }
  .list-item {
    border: 1px solid black;

    display: flex;
    align-items: center;
    // justify-content: space-between;
    width: 100%;
    height: 165px;
    font-size: 28px;
    margin-bottom: 13px;
    color: white;
    border-radius: 40px;
    padding: 0 20px 0 0;
    .avatar-box {
      position: relative;
      width: dPx(43.5);
      height: dPx(43.5);
      border-radius: 50%;
      margin-right: 66px;
      overflow: hidden;
      img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
      }

      .avatar {
        border-radius: 50%;
        object-fit: cover;
        z-index: 1;
      }
      .avatar-frame {
        border-radius: 50%;
        object-fit: cover;
        z-index: 2;
        width: 120%;
        height: 120%;
      }
    }
    .left,
    .right {
      display: flex;
      align-items: center;
    }
    .right {
      margin-left: 30px;
    }
    .left {
      width: 1px;
      flex: auto;
      .index {
        margin-left: 51px;
        margin-right: 51px;
        width: 30px;
        text-align: right;
        font-weight: 400;
      }
      img {
        // width: dPx(29.872);
        // height: dPx(29.872);
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid black;
      }
      .user-name {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
        font-size: dPx(16);
        flex: auto;
      }
    }
    .right {
      font-size: dPx(14);
      padding-right: 40px;
      flex: none;
    }
  }
  .gift-score {
    position: absolute;
    top: 3313px;
    left: 539px;
    color: white;
  }
}
</style>
